import { useNavigationHistory } from '../composables/useNavigationHistory'

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  const { history } = useNavigationHistory()

  history.value.push(to)
})
